import type { RouteParamsRequest } from '@pba/react-utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { PollContentObjectDetailDataObject } from 'models/service';

export const getPoll = async ({ routeParams: { id } }: RouteParamsRequest<{ id: string }>) =>
  apiClient.get<PollContentObjectDetailDataObject, ApiClientResponse<PollContentObjectDetailDataObject>>(
    routes.polls.get(id),
  );
